import {createRouter, createWebHistory} from 'vue-router'
import LoginView from "@/views/Auth/LoginView.vue";

import TokenTransactionsIndexView from "@/views/TokenTransactions/IndexView.vue";
import AdminTransactionsIndexView from "@/views/TokenTransactions/AdminTransactionsIndexView.vue";
import EmployersTransactionsIndexView from "@/views/TokenTransactions/EmployersIndexView.vue";


import EditProfileView from "@/views/Settings/EditProfile.vue";
import SignUpView from "@/views/Auth/SignUpView.vue";
import CompanySignUpView from "@/views/Auth/CompanySignUpView.vue";
import ForgotPasswordView from "@/views/Auth/ForgotPasswordView.vue";
import ResetPasswordView from "@/views/Auth/ResetPasswordView.vue";
import ChangePasswordView from "@/views/Settings/ChangePasswordView.vue";

import BuyTokensView from "@/views/TokenBuys/BuyTokensView.vue";

import TrainingCreateView from "@/views/Trainings/CreateView.vue";
import TrainingEditView from "@/views/Trainings/EditView.vue";
import TrainingEnrollView from "@/views/Trainings/EnrollView.vue";
import TrainingIndexView from "@/views/Trainings/IndexView.vue";
import TrainingsEnrollmentsView from "@/views/Trainings/EnrollmentsView.vue";
import TrainingShowView from "@/views/Trainings/ShowView.vue";
import TrainingsView from "@/views/Trainings/TrainingsView.vue";
import TrainingShareView from "@/views/Trainings/ShareView.vue";

import TrainingSeriesCreateView from "@/views/TrainingSeries/CreateView.vue";
import TrainingSeriesEditView from "@/views/TrainingSeries/EditView.vue";
import TrainingSeriesShowView from "@/views/TrainingSeries/ShowView.vue";
import TrainingSeriesShowTrainingView from "@/views/TrainingSeries/ShowTrainingView.vue";

import TrainingCategoriesIndexView from "@/views/TrainingCategories/IndexView.vue"
import TrainingTagsIndexView from "@/views/TrainingTags/IndexView.vue"

import EmployeesView from "@/views/Employees/EmployeesView.vue";
import EmployeesIndexView from "@/views/Employees/IndexView.vue";
import EmployeesCreateView from "@/views/Employees/CreateView.vue";
import EmployeesImportView from "@/views/Employees/ImportView.vue";
import EmployeesEditView from "@/views/Employees/EditView.vue";

import EmployersView from "@/views/Employers/EmployersView.vue";
import EmployersCreateView from "@/views/Employers/CreateView.vue";
import EmployersEditView from "@/views/Employers/EditView.vue";
import EmployersIndexView from "@/views/Employers/IndexView.vue";
import EmployersDetailsView from "@/views/Employers/DetailsView.vue";

import TrainersView from "@/views/Trainers/TrainersView.vue";
import TrainersCreateView from "@/views/Trainers/CreateView.vue";
import TrainersEditView from "@/views/Trainers/EditView.vue";
import TrainersIndexView from "@/views/Trainers/IndexView.vue";

import SetFirstPasswordView from "@/views/Auth/SetFirstPasswordView.vue";

import BuyTokensIndexView from "@/views/TokenBuys/IndexView.vue";

import DashboardView from "@/views/Dashboard/DashboardView.vue";

import CompaniesIndexView from "@/views/Companies/IndexView.vue";
import PendingWithdrawalsView from "@/views/Companies/PendingWithdrawalsView.vue";
import CompanyDetailsView from "@/views/Companies/DetailsView.vue";
import CompaniesView from "@/views/Companies/CompaniesView.vue";

import PrivacyPolicyView from "@/views/PrivacyPolicyView.vue";
import TermsAndConditionsView from "@/views/TermsAndConditionsView.vue";

import InvoicesIndexView from "@/views/Invoices/IndexView.vue";
import HomeView from "@/views/HomeView.vue";
import ContactView from "@/views/ContactView.vue";
import WithdrawalSettlementView from "@/views/Companies/WithdrawalSettlementView.vue";
import OTCLoginView from "@/views/Auth/OTCLoginView.vue";
import VerificationView from "@/views/Auth/VerificationView.vue";
import {headerState} from "@/stores/headerStore.js";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomeView,
            meta: {guest: true},
        },
        {
            path: '/logowanie',
            name: 'login',
            component: LoginView,
            meta: {guest: true},
        },
        {
            path: '/logowanie-kodem',
            name: 'otc-login',
            component: OTCLoginView,
            meta: {guest: true},
        },
        {
            path: '/weryfikacja',
            name: 'verification',
            component: VerificationView,
        },
        {
            path: '/kontakt',
            name: 'contact',
            component: ContactView,
            meta: {guest: true},
        },
        {
            path: '/rejestracja',
            name: 'sign-up',
            component: SignUpView,
            meta: {guest: true},
        },
        {
            path: '/rejestracja-firmy',
            name: 'company-sign-up',
            component: CompanySignUpView,
            meta: {guest: true},
        },
        {
            path: '/odzyskiwanie-hasla',
            name: 'password.forgot',
            component: ForgotPasswordView,
            meta: {guest: true},
        },
        {
            path: '/resetowanie-hasla',
            name: 'password.reset',
            component: ResetPasswordView,
            meta: {guest: true},
        },
        {
            path: '/ustaw-haslo',
            name: 'password.first-set',
            component: SetFirstPasswordView,
            meta: {guest: true},
        },
        {
            path: '/polityka-prywatnosci',
            name: 'static.privacy-policy',
            component: PrivacyPolicyView,
            meta: {guest: true},
        },
        {
            path: '/regulamin',
            name: 'static.terms-and-conditions',
            component: TermsAndConditionsView,
            meta: {guest: true},
        },
        {
            path: '/ustaw-haslo',
            name: 'password.first-set',
            component: SetFirstPasswordView,
            meta: {guest: true},
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: DashboardView,
        },
        {
            path: '/historia-szkolen',
            name: 'trainings.history',
            component: TrainingsEnrollmentsView,
            meta: {
                header: 'trainings.labels.enrolled_users'
            }
        },
        {
            path: '/kategorie-szkolen',
            name: 'training-categories.index',
            component: TrainingCategoriesIndexView,
            meta: {
                header: 'training_categories.labels.training_categories'
            }
        },
        {
            path: '/tagi-szkolen',
            name: 'training-tags.index',
            component: TrainingTagsIndexView,
            meta: {
                header: 'training_tags.labels.training_tags'
            }
        },
        {
            path: '/szkolenia',
            name: 'trainings.router-view',
            component: TrainingsView,
            children: [
                {
                    path: 'dodaj',
                    name: 'trainings.create',
                    component: TrainingCreateView,
                    meta: {
                        header: 'trainings.labels.new_training'
                    }
                },
                {
                    path: 'dodaj-serie',
                    name: 'training-series.create',
                    component: TrainingSeriesCreateView,
                    meta: {
                        header: 'training_series.labels.new_training'
                    }
                },
                {
                    path: ':id/edycja',
                    name: 'trainings.edit',
                    component: TrainingEditView,
                    meta: {
                        header: 'trainings.labels.editing_training'
                    }
                },
                {
                    path: 'serie/:id/edycja',
                    name: 'training-series.edit',
                    component: TrainingSeriesEditView,
                    meta: {
                        header: 'training_series.labels.editing_training'
                    }
                },
                {
                    path: ':id/zapis',
                    name: 'trainings.enroll',
                    component: TrainingEnrollView,
                    meta: {
                        header: 'trainings.labels.enrollment',
                        public: true
                    }
                },
                {
                    path: ':id/udostepnij',
                    name: 'trainings.share',
                    component: TrainingShareView,
                    meta: {
                        header: 'training_enrollments.labels.training_enrollment'
                    }
                },
                {
                    path: ':id',
                    name: 'trainings.show',
                    component: TrainingShowView,
                    meta: {
                        header: 'trainings.labels.training',
                        customHeader: true
                    }
                },
                {
                    path: '/seria/:id',
                    name: 'training-series.show',
                    component: TrainingSeriesShowView,
                    meta: {
                        header: 'trainings.labels.training',
                        customHeader: true
                    }
                },
                {
                    path: '/seria/:id/szkolenie/:training_id',
                    name: 'training-series.show-training',
                    component: TrainingSeriesShowTrainingView,
                    meta: {
                        header: 'trainings.labels.training',
                        customHeader: true
                    }
                },
                {
                    path: 'moje',
                    name: 'trainings.my',
                    component: TrainingIndexView,
                    meta: {
                        header: 'trainings.labels.my_trainings',
                        public: false
                    }
                },
                {
                    path: '',
                    name: 'trainings.index',
                    component: TrainingIndexView,
                    meta: {
                        header: 'trainings.labels.trainings',
                        public: true
                    }
                }
            ]
        },
        {
            path: '/pracownicy',
            name: 'employees.router-view',
            component: EmployeesView,
            children: [
                {
                    path: 'dodaj',
                    name: 'employees.create',
                    component: EmployeesCreateView,
                    meta: {
                        header: 'employees.labels.new_employee'
                    }
                },
                {
                    path: 'import',
                    name: 'employees.import',
                    component: EmployeesImportView,
                    meta: {
                        header: 'employees.labels.import_employees'
                    }
                },
                {
                    path: ':id/edycja',
                    name: 'employees.edit',
                    component: EmployeesEditView,
                    meta: {
                        header: 'employees.labels.editing_employee'
                    }
                },
                {
                    path: '',
                    name: 'employees.index',
                    component: EmployeesIndexView,
                    meta: {
                        header: 'employees.labels.employees'
                    }
                }
            ]
        },
        {
            path: '/szkoleniowcy',
            name: 'trainers.router-view',
            component: TrainersView,
            children: [
                {
                    path: 'dodaj',
                    name: 'trainers.create',
                    component: TrainersCreateView,
                    meta: {
                        header: 'trainers.labels.new_trainer'
                    }
                },
                {
                    path: ':id/edycja',
                    name: 'trainers.edit',
                    component: TrainersEditView,
                    meta: {
                        header: 'trainers.labels.editing_trainer'
                    }
                },
                {
                    path: '',
                    name: 'trainers.index',
                    component: TrainersIndexView,
                    meta: {
                        header: 'trainers.labels.trainers'
                    }
                }
            ]
        },
        {
            path: '/pracodawcy',
            name: 'employers.router-view',
            component: EmployersView,
            children: [
                {
                    path: 'dodaj',
                    name: 'employers.create',
                    component: EmployersCreateView,
                    meta: {
                        header: 'employers.labels.new_employer'
                    }
                },
                {
                    path: ':id',
                    name: 'employers.view',
                    component: EmployersDetailsView,
                    meta: {
                        header: 'employers.labels.employer_details'
                    }
                },
                {
                    path: ':id/edycja',
                    name: 'employers.edit',
                    component: EmployersEditView,
                    meta: {
                        header: 'employers.labels.editing_employer'
                    }
                },
                {
                    path: '',
                    name: 'employers.index',
                    component: EmployersIndexView,
                    meta: {
                        header: 'employers.labels.employers'
                    }
                }
            ]
        },
        {
            path: '/transakcje',
            name: 'token-transactions.index',
            component: TokenTransactionsIndexView,
            meta: {
                header: 'token_transactions.labels.my_transactions'
            }
        },
        {
            path: '/transakcje-pracownikow',
            name: 'employees-transactions.index',
            component: TokenTransactionsIndexView,
            meta: {
                header: 'token_transactions.labels.employees_transactions'
            }
        },
        {
            path: '/transakcje-pracodawcow',
            name: 'employers-transactions.index',
            component: EmployersTransactionsIndexView,
            meta: {
                header: 'token_transactions.labels.employers_transactions'
            }
        },
        {
            path: '/transakcje-z-administracja',
            name: 'token-transactions.admins-index',
            component: AdminTransactionsIndexView
        },
        {
            path: '/faktury',
            name: 'invoices.index',
            component: InvoicesIndexView,
            meta: {
                header: 'invoices.labels.invoices'
            }
        },
        {
            path: '/zarzadzanie-wyplatami',
            name: 'companies.router-view',
            component: CompaniesView,
            children: [
                {
                    path: '',
                    name: 'companies.index',
                    component: CompaniesIndexView,
                    meta: {
                        header: 'withdrawal_requests.labels.withdrawals_management'
                    },
                },
                {
                    path: 'oczekujace',
                    name: 'companies.pending-withdrawals',
                    component: PendingWithdrawalsView,
                    meta: {
                        header: 'withdrawal_requests.labels.pending_withdrawals'
                    },
                },
                {
                    path: ':id',
                    name: 'companies.show',
                    component: CompanyDetailsView,
                    meta: {
                        header: 'withdrawal_requests.labels.withdrawals_management'
                    },
                },
                {
                    path: ':id/rozliczenia/:settlementId',
                    name: 'companies.withdrawal-settlement',
                    component: WithdrawalSettlementView,
                    meta: {
                        header: 'withdrawal_settlements.labels.withdrawal_settlement_details'
                    },
                }
            ]
        },
        {
            path: '/wyplaty',
            name: 'withdrawal-requests.view',
            component: CompanyDetailsView,
            meta: {
                header: 'withdrawal_requests.labels.withdrawals_management'
            }
        },
        {
            path: '/zakup-tokenow',
            name: 'tokens.buy',
            component: BuyTokensView,
            meta: {
                header: 'token_purchases.labels.tokens_purchase'
            }
        },
        {
            path: '/zakupy-tokenow',
            name: 'tokens.buy-index',
            component: BuyTokensIndexView,
            meta: {
                header: 'token_purchases.labels.tokens_purchases'
            }
        },
        {
            path: '/moje-dane',
            name: 'profile.edit',
            component: EditProfileView,
            meta: {
                header: 'users.labels.my_profile'
            }
        },
        {
            path: '/zmiana-hasla',
            name: 'profile.change-password',
            component: ChangePasswordView,
        },
        {
            path: '/:catchall(.*)*',
            redirect: '/'
        }
    ],
});

router.beforeEach((to, from, next) => {
    if (!to.meta.customHeader) {
        headerState.clear()
    } else {
        headerState.clearSubtitle()
    }
    next()
})

export default router
